export default "__VITE_ASSET__6e92e864__"